<template>
  <form @submit.prevent="submitForm">
    <!-- Die Kosten der Maßnahme -->
    <div class="row">
      <h6 class="mb-2 text-uppercase ps-3">
        Die Kosten der Maßnahme werden:
      </h6>
    </div>
    <div class="row ms-3">
      <div class="col-lg-5 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.educationVoucher"
                      label="über einen Bildungsgutschein, abgerechnet"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-5 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.activationAndPlacementVoucher"
                      label="Aktivierungs- und Vermittlungsgutschein"
                      labelPosition="right"/>
      </div>
    </div>

    <!-- Lehrgangsgebühren -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase ps-3">
        In den Lehrgangsgebühren sind die Kosten für:
      </h6>
    </div>
    <div class="row ms-3">
      <div class="col-lg-3 col-md-6">
        <BaseCheckbox v-model="formData.costForBooks"
                      label="Bücher"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6">
        <BaseCheckbox v-model="formData.costForAudioUsage"
                      label="Audio-Nutzung"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6">
        <BaseCheckbox v-model="formData.costForExternalFees"
                      label="Externe Gebühren"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6">
        <BaseCheckbox v-model="formData.costForOthers"
                      label="Sonstige"
                      labelPosition="right"/>
      </div>
    </div>

    <div class="row mt-5 text-center">
      <div class="col-12">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const isSubmitting = ref(false);
const emit = defineEmits(['update:submitForm']);

const formData = ref<any>({
  educationVoucher: false,
  activationAndPlacementVoucher: false,
  costForBooks: false,
  costForAudioUsage: false,
  costForExternalFees: false,
  costForOthers: false,
});

async function submitForm() {
  try {
    await unemployedPrivateCoachingService.saveFurtherTrainingContract(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getFurtherTrainingContract(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getDocumentData();
});
</script>

